import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import type { FundingProductCards } from '@/api/kubik/credit'
import { useGetApprovedRegions } from '@/api/kubik/credit'
import { getUserRegion } from '@/logic/userRegion'
import type { ILoanProductsFilterForm } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsFilter/types'
import { INCREASE_LOAN_AMOUNT_BANNER_PRODUCT_INDEX } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsList/constants'
import type { RootState } from '@/redux/interfaces'
import { EFinancingProductId } from '@/types'

const mapState = (state: RootState) => ({
  userRegion: getUserRegion()(state),
})

export const useIncreaseLoanAmountBanner = (products: FundingProductCards[]) => {
  const form = useFormContext<ILoanProductsFilterForm>()
  const { userRegion } = useSelector(mapState)

  const { data } = useGetApprovedRegions({
    productId: EFinancingProductId.REPORT_CTRL2GO,
  })
  const formRegionCode = form.watch('regionCode')

  const shouldShowInLoansList = useMemo(() => {
    if (!formRegionCode) {
      const isRegionInHeaderApproved = data?.approvedRegions?.includes(userRegion.code) === true

      return isRegionInHeaderApproved
    }

    const isRegionInFormApproved = data?.approvedRegions?.includes(Number(formRegionCode)) === true

    return isRegionInFormApproved
  }, [data?.approvedRegions, formRegionCode, userRegion.code])

  const indexToInsert = useMemo(() => {
    if (!shouldShowInLoansList) {
      return 0
    }

    const mfoIndex = products.findIndex(({ productId }) => productId === EFinancingProductId.EXPRESS_MFO)
    const advanceFundingIndex = products.findIndex(({ productId }) => productId === EFinancingProductId.ADVANCE_FUNDING)
    const maxIndex = Math.max(mfoIndex, advanceFundingIndex)

    if (maxIndex === -1) {
      return INCREASE_LOAN_AMOUNT_BANNER_PRODUCT_INDEX
    }

    return maxIndex + 1
  }, [products, shouldShowInLoansList])

  return {
    shouldShowInLoansList,
    indexToInsert,
  }
}
